var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassCercle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1626 18H21.8374C21.3749 18 21 18.3749 21 18.8374C21 21.5027 22.0588 24.0588 23.9434 25.9434L25.1626 27.1626C25.2836 27.2836 25.3442 27.3442 25.3875 27.4023C25.6519 27.7569 25.6519 28.2431 25.3875 28.5977C25.3442 28.6558 25.2836 28.7164 25.1626 28.8374L23.9434 30.0566C22.0588 31.9412 21 34.4973 21 37.1626C21 37.6251 21.3749 38 21.8374 38H34.1626C34.6251 38 35 37.6251 35 37.1626C35 34.4973 33.9412 31.9412 32.0566 30.0566L30.8374 28.8374C30.7164 28.7164 30.6558 28.6558 30.6125 28.5977C30.3481 28.2431 30.3481 27.7569 30.6125 27.4023C30.6558 27.3442 30.7164 27.2836 30.8374 27.1626L32.0566 25.9434C33.9412 24.0588 35 21.5027 35 18.8374C35 18.3749 34.6251 18 34.1626 18Z",
    stroke: "#0860C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassCercle);
export default __webpack_public_path__ + "static/media/hourglass-cercle.f4517b93e736561770746e6cd9c134a1.svg";
export { ForwardRef as ReactComponent };